import { render, staticRenderFns } from "./IntentPayments.vue?vue&type=template&id=2278c156&scoped=true&"
import script from "./IntentPayments.vue?vue&type=script&lang=js&"
export * from "./IntentPayments.vue?vue&type=script&lang=js&"
import style0 from "./IntentPayments.vue?vue&type=style&index=0&id=2278c156&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278c156",
  null
  
)

export default component.exports